import { FoxIconTriangleRight } from 'aui-biz-icons';
import { Collapse } from 'aui';
import React from 'react';
import SupportIconPropsNode from '../Icon/SupportIconPropsNode';
import type { MdComponentIndexProps } from '../type';
import { mapSpecChildrenFactory } from '../utils/mapSpecChildren';
import { MarkdownAccordion } from './Accordion';
import './accordion.less';

const mapAcc = mapSpecChildrenFactory(MarkdownAccordion);

export function MarkdownAccordionGroup({
  children,
  ...props
}: React.PropsWithChildren<MdComponentIndexProps>) {
  const configList = mapAcc(
    children,
    ({ title, defaultOpen, icon, iconColor, ...rest }, key, child) => {
      return {
        key: String(key),
        header: (
          <div
            className="flex gap-1 items-center"
            data-first={rest['data-first']}
            data-last={rest['data-last']}
          >
            <SupportIconPropsNode icon={icon} iconColor={iconColor} />
            <span>{title}</span>
          </div>
        ),
        defaultOpen,
        children: <div className="markdown-child-root">{child}</div>,
      };
    },
  );
  return (
    <div
      data-markdown-component="x-accordion-container"
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <Collapse
        defaultActiveKey={configList
          .filter((item) => item.defaultOpen === true)
          .map((item) => item.key)}
        expandIcon={({ isActive }) => <FoxIconTriangleRight rotate={isActive ? 90 : 0} />}
      >
        {configList.map((item) => {
          return (
            <Collapse.Panel
              key={item.key}
              header={item.header}
              // extra={item.extra}
              className="markdown-child-root"
            >
              {item.children}
            </Collapse.Panel>
          );
        })}
      </Collapse>
    </div>
  );
}

MarkdownAccordionGroup.attributes = [] as string[];
MarkdownAccordionGroup.displayName = 'MarkdownAccordionGroup';
